import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("imube_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const WHATSAPP_NUMBER = "919594777669";
export const WHATSAPP_DISPLAY = "+91 95947 77669";
export const BRAND_EMAIL = "imubeglobal@gmail.com";
export const INSTAGRAM_HANDLE = "@imube.global";
export const INSTAGRAM_URL = "https://www.instagram.com/imube.global";
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_ube-trade-india/artifacts/1y285alc_im%20ube%20transparent%201024.png";

export function buildWhatsAppLink(text) {
  const msg = encodeURIComponent(text || "Hi I'm Ube team — I'd like a wholesale quote.");
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${msg}`;
}

export function formatErr(detail) {
  if (detail == null) return "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}
